import script from "./SortableSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SortableSelect.vue?vue&type=script&setup=true&lang=js"

import "./SortableSelect.vue?vue&type=style&index=0&id=b5ebd496&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ebd496"]])

export default __exports__